// src/storage/index.js

import StorageAdapter from './StorageAdapter.js';
import IndexedDBAdapter from './IndexedDBAdapter.js';
import MemoryAdapter from './MemoryAdapter.js';
import IndexerSettings from './IndexerSettings.js';

/**
 * Select appropriate storage adapter based on config, environment, and user settings.
 * @param {Object} config - Persistence configuration
 * @returns {StorageAdapter}
 */
function selectAdapter(config) {
  // Explicit memory mode in config
  if (config?.type === 'memory') {
    return new MemoryAdapter();
  }

  // Check user preference - if storage disabled, use memory
  if (!IndexerSettings.isStorageEnabled()) {
    console.log('[EventIndexer] User disabled IndexedDB storage, using memory');
    return new MemoryAdapter();
  }

  // Check IndexedDB availability
  if (typeof indexedDB !== 'undefined') {
    return new IndexedDBAdapter();
  }

  // Fallback to memory
  console.warn('[EventIndexer] IndexedDB not available, falling back to memory storage');
  return new MemoryAdapter();
}

export {
  StorageAdapter,
  IndexedDBAdapter,
  MemoryAdapter,
  IndexerSettings,
  selectAdapter
};
